export const saveSessionDocument = (document) => {
  try {
    sessionStorage.setItem("document", JSON.stringify(document));
    // console.log(
    //   'Documento guardado en sessionStorage con la clave "document".'
    // );
  } catch (error) {
    // console.error("Error al guardar el documento en sessionStorage:", error);
  }
};

export const getSessionDocument = () => {
  try {
    const document = sessionStorage.getItem("document");
    if (document) {
      // console.log(
      //   'Documento obtenido de sessionStorage con la clave "document". ' + document
      // );
      return JSON.parse(document);
    } else {
      // console.log(
      //   'No se encontró ningún documento en sessionStorage con la clave "document".'
      // );
      return null;
    }
  } catch (error) {
    // console.error("Error al obtener el documento de sessionStorage:", error);
    return null;
  }
};

export const saveSessionPasoPago = (value) => {
    sessionStorage.setItem("pasoPago", value);  
};

export const getSessionPasoPago = () => {
    return sessionStorage.getItem("pasoPago");    
};

export const saveSessionTipoTarjetaPlata = (value) => {
  sessionStorage.setItem("tipoTarjetaPlata", value);  
};

export const getSessionTipoTarjetaPlata = () => {
  return sessionStorage.getItem("tipoTarjetaPlata");    
};

export const incrementPhoneValidationAttempts = () => {
  try {
    const currentAttempts = getPhoneValidationAttempts() || 0;
    const newAttempts = currentAttempts + 1;

    savePhoneValidationAttempts(newAttempts);

    // if (newAttempts >= 4) {
    //   console.log("Se alcanzaron 4 intentos de validación del celular.");
    // }
  } catch (error) {
    // console.error("Error al incrementar los intentos de validación:", error);
  }
};

export const savePhoneValidationAttempts = (attempts) => {
  try {
    sessionStorage.setItem("attempts", JSON.stringify(attempts));
  } catch (error) {
    // console.error("Error al guardar los intentos en sessionStorage:", error);
  }
};

export const getPhoneValidationAttempts = () => {
  try {
    const attempts = sessionStorage.getItem("attempts");
    if (attempts) {
      // console.log(
      //   'Intentos obtenidos de sessionStorage con la clave "attempts".'
      // );
      return JSON.parse(attempts);
    } else {
      // console.log(
      //   'No se encontró ningún número de intentos en sessionStorage con la clave "attempts".'
      // );
      return null;
    }
  } catch (error) {
    // console.error(
    //   "Error al obtener la cantidad de intentos del sessionStorage:",
    //   error
    // );
    return null;
  }
};
